import React from 'react';
import { Button } from '../components/ui/button';
import { 
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '../components/ui/dropdown-menu';
import { Play, Pause, Zap, Trash2 } from 'lucide-react';

const StreamControls = ({
  isStreaming,
  streamSpeed,
  onStartStop,
  onSpeedChange,
  onInjectScenario,
  onClear
}) => {
  return (
    <div className="flex items-center gap-2 flex-wrap" aria-label="Stream controls">
      {/* Start/Stop */}
      <Button
        size="sm"
        variant={isStreaming ? "destructive" : "default"}
        onClick={onStartStop}
        data-testid={isStreaming ? "stream-stop-button" : "stream-start-button"}
      >
        {isStreaming ? (
          <>
            <Pause className="h-3.5 w-3.5 mr-1.5" />
            Stop
          </>
        ) : (
          <>
            <Play className="h-3.5 w-3.5 mr-1.5" />
            Start Stream
          </>
        )}
      </Button>

      {/* Inject Scenario */}
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button 
            size="sm" 
            variant="outline"
            data-testid="stream-inject-scenario-button"
          >
            <Zap className="h-3.5 w-3.5 mr-1.5" />
            Inject Scenario
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem onClick={() => onInjectScenario('pricing_confusion')}>
            👥 Pricing Confusion Spike
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => onInjectScenario('onboarding_bug')}>
            🐛 Onboarding Bug Spike
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => onInjectScenario('feature_request_wave')}>
            🚀 Feature Request Wave
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      {/* Clear */}
      <Button
        size="sm"
        variant="outline"
        onClick={onClear}
        data-testid="stream-clear-button"
      >
        <Trash2 className="h-3.5 w-3.5 mr-1.5" />
        Clear
      </Button>
    </div>
  );
};

export default StreamControls;
